import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function AdminSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { icon: 'ri-dashboard-line', label: '대시보드', path: '/admin/dashboard' },
    { icon: 'ri-user-star-line', label: '크리에이터 관리', path: '/admin/creators' },
    { icon: 'ri-user-heart-line', label: '팬 관리', path: '/admin/fans' },
    { icon: 'ri-exchange-line', label: '거래 내역', path: '/admin/transactions' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* 모바일 햄버거 버튼 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 w-12 h-12 bg-white rounded-xl shadow-lg flex items-center justify-center cursor-pointer"
      >
        <i className={`${isOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-800`}></i>
      </button>

      {/* 오버레이 */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="lg:hidden fixed inset-0 bg-black/50 z-40"
        ></div>
      )}

      {/* 사이드바 */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white border-r border-gray-200 z-40 transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        <div className="flex flex-col h-full">
          {/* 로고 */}
          <div className="p-6 border-b border-gray-200">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent">
              Admin Panel
            </h1>
            <p className="text-sm text-gray-600 mt-1">관리자 대시보드</p>
          </div>

          {/* 메뉴 */}
          <nav className="flex-1 p-4 space-y-2">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  navigate(item.path);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all cursor-pointer whitespace-nowrap ${
                  isActive(item.path)
                    ? 'bg-gradient-to-r from-teal-500 to-blue-500 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                <i className={`${item.icon} text-xl`}></i>
                <span className="font-semibold text-sm">{item.label}</span>
              </button>
            ))}
          </nav>

          {/* 하단 */}
          <div className="p-4 border-t border-gray-200">
            <button
              onClick={() => {
                navigate('/');
                setIsOpen(false);
              }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-gray-700 hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-logout-box-line text-xl"></i>
              <span className="font-semibold text-sm">홈으로</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}